/**
 * Firestore implementation of VendorRepository.
 *
 * Path: vendors/{vendorId}
 *
 * Vendor master data — supplier records referenced by purchase requisitions
 * and (later) purchase orders. See src/types/vendor.ts.
 */

import { collection, doc, getDoc, setDoc, deleteDoc, getDocs } from 'firebase/firestore';
import { db } from '../../../lib/firebase';
import type { Vendor, EntityId } from '../../../types';
import type { VendorRepository, VendorListFilter } from '../types';

const COLLECTION = 'vendors';

export const firestoreVendorRepository: VendorRepository = {
  async findById(id: EntityId): Promise<Vendor | null> {
    const snap = await getDoc(doc(db, COLLECTION, id));
    return snap.exists() ? (snap.data() as Vendor) : null;
  },

  async save(entity: Vendor): Promise<void> {
    await setDoc(doc(db, COLLECTION, entity.id), entity);
  },

  async delete(id: EntityId): Promise<void> {
    await deleteDoc(doc(db, COLLECTION, id));
  },

  async list(filter?: VendorListFilter): Promise<Vendor[]> {
    const snap = await getDocs(collection(db, COLLECTION));
    let vendors = snap.docs.map((d) => d.data() as Vendor);
    if (filter?.status?.length) {
      vendors = vendors.filter((v) => filter.status!.includes(v.status));
    }
    return vendors;
  },
};
